import React from 'react';
import { View } from 'react-navi';
import { mount, compose, withView, redirect } from 'navi';
import ReactGA from 'react-ga';
import ProfileApp from './profiles';
import ListApp from './list';

const apps = compose(
  withView((request: any) => {
    if (process.env.REACT_APP_CONTEXT === 'production') {
      ReactGA.pageview(request.path);
    }
    return (
        <>
            <div className="is-frecam cpck-window cpck-banner cpck-type-info cpck-theme-block cpck-bottom">
                <span id="cupcakeconsent:desc" className="cpck-message"><strong className="has-text-weight-bold">2026年度 新1年生募集中！</strong><br />2010年度の初開催から続く歴史の中で、夢を抱く学生たちがこの舞台から羽ばたき、アナウンサーやタレント、アイドル、インフルエンサーとして活躍しています。</span>
                <div className="cpck-compliance">
                    <a aria-label="dismiss cookie message"
                        href="https://liff.line.me/1653526546-OmK7dK4L/entry?utm_source=frecam2022&utm_medium=operation"
                        className="cpck-btn cpck-dismiss"><span>🌸</span>エントリー方法を確認する</a>
                </div>
            </div>
            <View />
        </>
    );
  }),
  mount({
    '/': redirect('/list'),
    '/list': ListApp,
    '/entry': ProfileApp,
  }),
);

export default apps;
